import * as m from "./../../dist/es2015/wc.js";
export const am5wc = m;